import { createTRPCProxyClient, httpBatchLink, httpLink } from '@trpc/client'
import type { AppRouter } from 'svc-auction'
import { getUserToken } from '../../utils/localStorage'
console.log('auctionApi', import.meta.env.VITE_AUCTION_API_URL)
const baseUrl = import.meta.env.VITE_AUCTION_API_URL

export const auctionApi = createTRPCProxyClient<AppRouter>({
  links: [
    httpLink({
      url: baseUrl,
      async headers() {
        return {
          authorization: 'Bearer ' + getUserToken(),
        }
      },
    }),
  ],
})
